import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  OrganizationKnowledgeRequests,
  OrganizationKnowledgeResponses,
} from "@costory/types/endpoints/organizationKnowledge"

import { apiClientWithTimeout } from "@costory/front/lib/apiClient"

export const useOrganizationKnowledge = () => {
  return useQuery<OrganizationKnowledgeResponses.OrganizationKnowledge[]>({
    queryKey: ["organizationKnowledge"],
    queryFn: async () => {
      const response = await apiClientWithTimeout.get<
        OrganizationKnowledgeResponses.OrganizationKnowledge[]
      >("/organization-knowledge")
      return response.data
    },
  })
}

export const useCreateOrganizationKnowledge = () => {
  const queryClient = useQueryClient()

  return useMutation<
    OrganizationKnowledgeResponses.New,
    Error,
    OrganizationKnowledgeRequests.New
  >({
    mutationFn: async (data) => {
      const response =
        await apiClientWithTimeout.post<OrganizationKnowledgeResponses.New>(
          "/organization-knowledge",
          data,
        )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organizationKnowledge"] })
    },
  })
}
